import { useRouter } from "@core/Api/useRouter";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import SignInEnterpriseModal from "@ext/enterprise/components/SingInOut/SignInEnterpriseModal";
import { LogoutButton, UserAvatar } from "../../../../components/UserAvatar";

export const SignInDocportal = () => {
	const router = useRouter();
	const apiUrlCreator = ApiUrlCreatorService.value;
	const isLogged = PageDataContextService.value.isLogged;
	const authUrl = apiUrlCreator.getAuthUrl(router, isLogged).toString();

	if (isLogged) return <UserAvatar logoutComponent={<LogoutButton authUrl={authUrl} />} />;
	return <SignInEnterpriseModal authUrl={authUrl} />;
};
